import React, { useEffect, useState } from 'react';
import { useLocation, Navigate } from "react-router-dom";
import { useCookies } from 'react-cookie';

import { API_AUTH_USER, VIEW_LOGIN } from "../../common/SkConstants";
import { serverUrl } from "../../common/SkEnv";

const AuthContext = React.createContext( null );

export function useAuth() {
    return React.useContext( AuthContext );
}

const checkAdmin = (roles) => {
    if ( roles == null ) return false;
    if ( !roles ) return false;
    for( let role of roles ) {
        if ( role.authority === "ROLE_ADMIN" ) return true;
    }
    return false;
}

export function AuthProvider( { children } ) {
    const [ isAuthenticated, setIsAuthenticated ] = useState( false );
    const [ isAdmin, setIsAdmin ] = useState( false );
    const [ user, setUser ] = useState( undefined );
    const [ loading, setLoading ] = useState( false) ;
    const [ cookies ] = useCookies( [ 'XSRF-TOKEN' ] );

    useEffect(() => {
        setLoading( true );
        fetch( serverUrl + API_AUTH_USER, {
            mode: 'no-cors',
            credentials: 'include'
        })
        .then( response => response.text() )
        .then( body => {
            if ( body === '' ) {
                setUser( null );
                setIsAuthenticated( false );
            } else {
                const authUser = JSON.parse( body );
                setUser( authUser.attributes.name );
                setIsAdmin( checkAdmin( authUser.authorities ) );
                setIsAuthenticated( true );
            }
            setLoading( false );
        });
    }, [ setIsAuthenticated, setIsAdmin, setUser, setLoading ] )

    const aExports = { isAuthenticated: isAuthenticated, isAdmin: isAdmin, user }

    return <AuthContext.Provider value={ aExports }> {children} </AuthContext.Provider>
}

export function RequireAuth( { children } ) {
    const auth = useAuth();
    const location = useLocation();

    if ( !auth.user ) {
        return <Navigate to={ VIEW_LOGIN } state={{ from: location }} replace />
    }

    return children;
}
